export default (strings, id) => {
	if( strings && strings.edges ){
		const filtered = strings.edges.filter(({node}) => node.originalId === id)[0]
		if(filtered) return filtered.node.string
	}
	return 'string with id ' + id + ' not found'
}